import axios from "axios";

const BASE = "/ncrm/workflows/instances";

export const fetchWorkflowInstances = () =>
  axios.get(BASE);

export const createWorkflowInstanceApi = (payload) =>
  axios.post(BASE, payload);

export const updateWorkflowInstanceApi = (workflowId, payload) =>
  axios.patch(`${BASE}/${workflowId}`, payload);

export const updateWorkflowNodeSettingsApi = (workflowId, nodeKey, settings) =>
  axios.patch(`${BASE}/${workflowId}/node-settings/${nodeKey}`, settings);

export const deleteWorkflowInstanceApi = (workflowId) =>
  axios.delete(`${BASE}/${workflowId}`);
